import { render, staticRenderFns } from "./claim_view.vue?vue&type=template&id=3bef4c94&scoped=true"
import script from "./claim_view.vue?vue&type=script&lang=js"
export * from "./claim_view.vue?vue&type=script&lang=js"
import style0 from "./claim_view.vue?vue&type=style&index=0&id=3bef4c94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bef4c94",
  null
  
)

export default component.exports